(() => {
  const SCENTS = {
    glow: {name:"Soft Life Glow",collection:"Luxe Body Oil",mood:"Clean · Soft · Radiant",notes:"vanilla · marshmallow · caramel · musk",why:"You're drawn to warmth and ease — a soft, glowing everyday scent that feels like home."},
    champ:{name:"Champagne Dreams",collection:"Luxe Body Oil",mood:"Sweet · Feminine · Playful",notes:"champagne · berries · violet · cashmere musk",why:"You love a little sparkle. This is your celebration in a bottle — bright, bubbly, and feminine."},
    rich:{name:"Rich Energy",collection:"Luxe Body Oil",mood:"Bold · Confident · Unforgettable",notes:"amber · saffron · cedar · jasmine",why:"You walk in and the room notices. Warm, magnetic, and unisex — your signature power scent."},
    date:{name:"Date Night",collection:"Luxe Body Oil",mood:"Sexy · Romantic · Alluring",notes:"rose · jasmine · amber · vanilla bean",why:"You're all sensuality and romance. This is the scent for the moments you want remembered."},
    sge:{name:"Soft Girl Era",collection:"Luxe Body Oil",mood:"Soft · Pretty · Dreamy",notes:"peony · jasmine · suede · musk",why:"You're soft and unbothered, pretty and at peace. This delicate floral musk is pure soft-girl energy."},
    sgeShim:{name:"Soft Girl Era Shimmer",collection:"Shimmer Body Oil",mood:"Glowy · Feminine · Dreamy",notes:"peony · jasmine · suede · musk + golden shimmer",why:"You want the softness and the glow. Same dreamy florals, now catching the light."},
    cdShim:{name:"Champagne Dreams Shimmer",collection:"Shimmer Body Oil",mood:"Sparkling · Flirty · Radiant",notes:"champagne · berries · violet · musk + golden shimmer",why:"Playful and luminous — your flirtiest, most radiant self, shimmering."},
    reShim:{name:"Rich Energy Shimmer",collection:"Shimmer Body Oil",mood:"Golden · Bold · Magnetic",notes:"amber · saffron · cedar · jasmine + golden shimmer",why:"Bold meets golden glow. The confident scent with a magnetic shimmer to match."},
    golden:{name:"Golden Glow Facial Elixir",collection:"Facial Elixir",mood:"Nourish · Glow · Renew",notes:"fragrance-free nourishing facial oil",why:"Your softness starts with your skin. This is your glow ritual — pure nourishment, renewal, radiance."}
  };

  const QUESTIONS = [
    {q:"How do you want to feel when you walk into a room?",opts:[
      {t:"Effortless and at ease",w:{glow:2,sge:1}},
      {t:"Like the moment just got brighter",w:{champ:2,cdShim:1}},
      {t:"Bold and unforgettable",w:{rich:2,reShim:1}},
      {t:"Soft, glowing, lit from within",w:{golden:2,sgeShim:1}}
    ]},
    {q:"Pick the vibe that feels most like you:",opts:[
      {t:"Cozy sweater, vanilla candle, slow morning",w:{glow:2,golden:1}},
      {t:"Champagne, confetti, good friends",w:{champ:2,cdShim:1}},
      {t:"Power suit, gold jewelry, main character",w:{rich:2,reShim:1}},
      {t:"Silk robe, fresh flowers, soft music",w:{sge:2,date:1}}
    ]},
    {q:"What kind of glow are you after?",opts:[
      {t:"A natural, lit-from-within softness",w:{glow:2,golden:2}},
      {t:"A literal shimmer that catches light",w:{sgeShim:3,cdShim:3,reShim:3}},
      {t:"A warm, golden, magnetic radiance",w:{rich:1,reShim:2}},
      {t:"Dewy, healthy, glowing skin first",w:{golden:3}}
    ]},
    {q:"Your ideal scent leaves people thinking…",opts:[
      {t:"“She smells so soft and pretty”",w:{sge:2,sgeShim:1}},
      {t:"“She smells expensive”",w:{rich:2,date:1}},
      {t:"“She smells sweet and fun”",w:{champ:2,glow:1}},
      {t:"“She smells romantic and alluring”",w:{date:3}}
    ]},
    {q:"Last one — when do you most want to feel your scent?",opts:[
      {t:"Every single day, as my signature",w:{glow:2,sge:1}},
      {t:"Date night and special evenings",w:{date:2,reShim:2}},
      {t:"Celebrations and nights out",w:{champ:1,cdShim:3}},
      {t:"As a self-care ritual, just for me",w:{golden:2,glow:1}}
    ]}
  ];

  const RESULT_DETAILS = {
    glow:{perfect:"Slow mornings · Everyday softness · Cozy layering",pairs:"Kayali Vanilla 28 · Burberry Goddess · Eilish"},
    champ:{perfect:"Brunch dates · Celebrations · Playful nights out",pairs:"Burberry Her · Champagne Toast · fruity florals"},
    rich:{perfect:"Power moments · Evening plans · Signature scent energy",pairs:"Baccarat Rouge 540 · warm ambers · saffron scents"},
    date:{perfect:"Date nights · Romantic evenings · Special occasions",pairs:"rose perfumes · jasmine florals · warm vanilla"},
    sge:{perfect:"Soft-life days · Brunch · Fresh flowers and ease",pairs:"peony perfumes · clean musk · floral skin scents"},
    sgeShim:{perfect:"Golden-hour plans · Vacations · Soft-glam moments",pairs:"peony florals · clean musk · airy jasmine"},
    cdShim:{perfect:"Birthdays · Girls’ nights · Celebration glow",pairs:"berry perfumes · sparkling florals · sweet musk"},
    reShim:{perfect:"Nightlife · Events · Main-character entrances",pairs:"amber perfumes · saffron scents · woody florals"},
    golden:{perfect:"Morning skincare · Self-care resets · Fragrance-free glow",pairs:"Your complete Soft Life Skin ritual"}
  };

  const ROOT_SELECTOR = "[data-soft-life-scent-quiz]";

  function readGuest() {
    try {
      return JSON.parse(localStorage.getItem("sleConciergeGuest") || "null");
    } catch (error) {
      return null;
    }
  }

  function slugify(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function saveLocalResult(resultName) {
    const guest = readGuest();
    if (!guest) return;

    guest.results = guest.results || {};
    guest.results.signatureScent = {
      result: resultName,
      completedAt: new Date().toISOString()
    };

    localStorage.setItem("sleConciergeGuest", JSON.stringify(guest));
  }

  function initQuiz(root) {
    if (!root || root.dataset.slSqInitialized === "true") return;

    const stage = root.querySelector("[data-stage]");
    const progress = root.querySelector("[data-progress]");
    const questionTemplate = root.querySelector("[data-question-template]");
    const gateTemplate = root.querySelector("[data-gate-template]");
    const resultTemplate = root.querySelector("[data-result-template]");

    if (!stage || !progress || !questionTemplate || !gateTemplate || !resultTemplate) return;

    root.dataset.slSqInitialized = "true";
    const introMarkup = stage.innerHTML;
    const requireEmail = root.dataset.requireEmail === "true";

    const productMap = {
      glow:{url:root.dataset.glowUrl||"/collections/all",image:root.dataset.glowImage||""},
      champ:{url:root.dataset.champUrl||"/collections/all",image:root.dataset.champImage||""},
      rich:{url:root.dataset.richUrl||"/collections/all",image:root.dataset.richImage||""},
      date:{url:root.dataset.dateUrl||"/collections/all",image:root.dataset.dateImage||""},
      sge:{url:root.dataset.sgeUrl||"/collections/all",image:root.dataset.sgeImage||""},
      sgeShim:{url:root.dataset.sgeShimUrl||"/collections/all",image:root.dataset.sgeShimImage||""},
      cdShim:{url:root.dataset.cdShimUrl||"/collections/all",image:root.dataset.cdShimImage||""},
      reShim:{url:root.dataset.reShimUrl||"/collections/all",image:root.dataset.reShimImage||""},
      golden:{url:root.dataset.goldenUrl||"/collections/all",image:root.dataset.goldenImage||""}
    };

    let current = 0;
    let answers = [];
    let scores = createScores();

    function createScores() {
      return Object.keys(SCENTS).reduce((accumulator,key)=>{
        accumulator[key]=0;
        return accumulator;
      },{});
    }

    function resetState() {
      current=0;
      answers=[];
      scores=createScores();
    }

    function renderProgress(mode="quiz") {
      progress.innerHTML="";
      QUESTIONS.forEach((_,index)=>{
        const segment=document.createElement("span");
        if(mode==="complete"||index<current) segment.classList.add("is-done");
        if(mode==="quiz"&&index===current) segment.classList.add("is-active");
        progress.appendChild(segment);
      });
      progress.hidden=false;
    }

    function renderIntro() {
      resetState();
      progress.hidden=true;
      stage.innerHTML=introMarkup;
      stage.scrollIntoView({behavior:"smooth",block:"nearest"});
    }

    function renderQuestion() {
      renderProgress("quiz");
      const question=QUESTIONS[current];
      const fragment=questionTemplate.content.cloneNode(true);

      fragment.querySelector("[data-question-number]").textContent=
        `Question ${current+1} of ${QUESTIONS.length}`;
      fragment.querySelector("[data-question-text]").textContent=question.q;

      const options=fragment.querySelector("[data-options]");
      question.opts.forEach((option,index)=>{
        const button=document.createElement("button");
        button.type="button";
        button.className="sl-sq-option";
        button.dataset.optionIndex=String(index);
        button.textContent=option.t;
        options.appendChild(button);
      });

      const back=fragment.querySelector("[data-back]");
      back.hidden=current===0;
      stage.replaceChildren(fragment);

      const heading=stage.querySelector("[data-question-text]");
      if(heading){
        heading.setAttribute("tabindex","-1");
        heading.focus({preventScroll:true});
      }

      stage.scrollIntoView({behavior:"smooth",block:"nearest"});
    }

    function chooseAnswer(optionIndex) {
      const question=QUESTIONS[current];
      const weights=question.opts[optionIndex].w;

      answers[current]=optionIndex;
      Object.keys(weights).forEach((key)=>{scores[key]+=weights[key];});
      current+=1;

      if(current<QUESTIONS.length){
        renderQuestion();
        return;
      }

      const guest=readGuest();

      if(guest && guest.email){
        const result=topScent();
        captureEmail(guest.email,result.scent.name,guest);
        saveLocalResult(result.scent.name);
        renderResult();
      } else if(requireEmail){
        renderGate();
      } else {
        renderResult();
      }
    }

    function goBack() {
      if(current===0) return;
      current-=1;
      const previousAnswer=answers[current];

      if(previousAnswer!==undefined){
        const weights=QUESTIONS[current].opts[previousAnswer].w;
        Object.keys(weights).forEach((key)=>{scores[key]-=weights[key];});
      }

      renderQuestion();
    }

    function renderGate() {
      renderProgress("complete");
      stage.replaceChildren(gateTemplate.content.cloneNode(true));
      const input=stage.querySelector("[data-email]");
      if(input) input.focus({preventScroll:true});
      stage.scrollIntoView({behavior:"smooth",block:"nearest"});
    }

    function topScent() {
      let bestKey=Object.keys(SCENTS)[0];
      let bestScore=-Infinity;

      Object.keys(scores).forEach((key)=>{
        if(scores[key]>bestScore){
          bestScore=scores[key];
          bestKey=key;
        }
      });

      return {key:bestKey,scent:SCENTS[bestKey]};
    }

    async function captureEmail(email,resultName,guest={}) {
      const eventTag=slugify(guest.event || "website-concierge");
      const resultTag="concierge-result-"+slugify(resultName);

      const tags=[
        "newsletter",
        "soft-life-concierge",
        "concierge-completed",
        "concierge-experience-signature-scent",
        resultTag,
        eventTag
      ].filter(Boolean).join(",");

      const formData=new FormData();
      formData.append("form_type","customer");
      formData.append("utf8","✓");
      formData.append("contact[email]",email);
      formData.append("contact[accepts_marketing]","true");
      formData.append("contact[tags]",tags);

      if(guest.name){
        formData.append("contact[first_name]",guest.name);
      }

      formData.append(
        "contact[note]",
        `Soft Life Concierge | Experience: Signature Scent | Result: ${resultName} | Event: ${guest.event || "website-concierge"}`
      );

      try{
        const rootPath=
          window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root
            ? window.Shopify.routes.root
            : "/";

        await fetch(`${rootPath}contact#contact_form`,{
          method:"POST",
          body:formData,
          credentials:"same-origin"
        });
      }catch(error){
        console.warn("Concierge result capture failed.",error);
      }
    }

    function submitEmail() {
      const input=stage.querySelector("[data-email]");
      const error=stage.querySelector("[data-email-error]");
      const email=input?input.value.trim().toLowerCase():"";
      const valid=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if(!valid){
        if(error) error.textContent="Please enter a valid email address.";
        if(input) input.focus();
        return;
      }

      if(error) error.textContent="";

      const result=topScent();
      const guest=readGuest() || {email:email,event:"website-concierge"};
      guest.email=email;

      localStorage.setItem("sleConciergeGuest",JSON.stringify(guest));
      captureEmail(email,result.scent.name,guest);
      saveLocalResult(result.scent.name);
      renderResult();
    }

    function renderResult() {
      renderProgress("complete");

      const {key,scent}=topScent();
      const product=productMap[key]||{url:"/collections/all",image:""};
      const details=RESULT_DETAILS[key]||{perfect:"",pairs:""};
      const fragment=resultTemplate.content.cloneNode(true);
      const result=fragment.querySelector("[data-result]");

      fragment.querySelector("[data-result-name]").textContent=scent.name;
      fragment.querySelector("[data-result-collection]").textContent=scent.collection;
      fragment.querySelector("[data-result-mood]").textContent=scent.mood;
      fragment.querySelector("[data-result-notes]").textContent=scent.notes;
      fragment.querySelector("[data-result-why]").textContent=scent.why;
      fragment.querySelector("[data-result-perfect]").textContent=details.perfect;
      fragment.querySelector("[data-result-pairs]").textContent=details.pairs;

      const image=fragment.querySelector("[data-result-image]");
      const placeholder=fragment.querySelector("[data-result-placeholder]");

      if(product.image){
        image.src=product.image;
        image.alt=scent.name;
        image.hidden=false;
        placeholder.hidden=true;
      }else{
        image.hidden=true;
        placeholder.hidden=false;
      }

      const link=fragment.querySelector("[data-result-link]");
      link.href=product.url;
      fragment.querySelector("[data-result-button]").textContent=`Shop ${scent.name}`;

      stage.replaceChildren(fragment);
      requestAnimationFrame(()=>result.classList.add("is-visible"));

      const heading=stage.querySelector("[data-result-name]");
      if(heading){
        heading.setAttribute("tabindex","-1");
        heading.focus({preventScroll:true});
      }

      stage.scrollIntoView({behavior:"smooth",block:"nearest"});
    }

    root.addEventListener("click",(event)=>{
      if(event.target.closest("[data-start-quiz]")){
        resetState();
        renderQuestion();
        return;
      }

      const option=event.target.closest("[data-option-index]");
      if(option){
        chooseAnswer(Number(option.dataset.optionIndex));
        return;
      }

      if(event.target.closest("[data-back]")){
        goBack();
        return;
      }

      if(event.target.closest("[data-reveal]")){
        submitEmail();
        return;
      }

      if(event.target.closest("[data-skip]")){
        renderResult();
        return;
      }

      if(event.target.closest("[data-retake]")){
        renderIntro();
      }
    });

    root.addEventListener("keydown",(event)=>{
      if(event.key==="Enter"&&event.target.matches("[data-email]")){
        event.preventDefault();
        submitEmail();
      }
    });
  }

  function initAll(scope=document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initQuiz);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",()=>initAll());
  }else{
    initAll();
  }

  document.addEventListener("shopify:section:load",(event)=>initAll(event.target));
})();